export default __webpack_public_path__ + "static/media/argentan16.38894c0e.jpg";